import { IAutomationObject } from '../../../types'

export interface IHeatingOutlet_Optimizer extends IAutomationObject {
    flowBase: number;
    flowMax: number;
    outTBase: number;
    outTMax: number;
    actSetpoint: number;
    flow1: number;
    flow2: number;
    outT1: number;
    outT2: number;
    outsideTemperature: number;
    roomTemperature: number;
    setpointRT:number;
    baseTemperature:number;
    factor:number;
    maxRTCorrection:number;
    maxOffsetRT:number;
    activateRTCorection:boolean;
    factorForecast: number;
    tempNextDayMin: number;
    tempNextDayMax: number;
    enableForecast: boolean;
    correctionTempForecast: number;
    
    onValueChanged: any;
}

export type  ILine = {
    lines: 
        {
            name: string,
            points:  IPoint[],
            key: any
        }[]
}
export type  IPoint = {
    x: number,
    y: number
}
export const schema = 'AutomationApps.Plants.Optimizations.HeatingOutlet_Optimizer';



    